// The one loading treatment for a conversation surface that is not ready:
// the grey petal tick beside quiet copy, matching the thinking line rather
// than a bare sentence.
import { type ReactNode } from 'react';

import { PetalTickLoader } from '@apps/web/features/phoebe_chat_v3/ui/primitives/petal_tick_loader';

export function ConversationLoading({
    copy = 'Opening conversation…',
}: Readonly<{ readonly copy?: string }>): ReactNode {
    return (
        <div
            role="status"
            className="text-muted-foreground text-v3-chat flex h-full items-center justify-center gap-2"
        >
            {/* This wrapper is the announced status, so the loader's own
                status role stays hidden to avoid a second announcement. */}
            <span aria-hidden="true" className="inline-flex">
                <PetalTickLoader className="size-4" />
            </span>
            <span>{copy}</span>
        </div>
    );
}
